import _ from "lodash";

import firebaseapp from "../firebase.js";

const firestoreDB = firebaseapp.firestore();

export default class CropService {
  static getAllCrops = async () => {
    let snapshot = await firestoreDB.collection("crops").get();
    return snapshot.docs.map((doc) => doc.data());
  };
  static getCropByName = (crops, cropName) => {
    let crop = null;
    cropName = cropName.toLowerCase();
    cropName = cropName.trim();
    crop = _.filter(crops, (crop) => {
      return crop[`name_en`].toLowerCase() === cropName;
    });
    return crop[0] ? crop[0] : null;
  };

  static getVideosCount(crop, userState, userType) {
    let videosCount = 0;
    let derivedUserType = "premium";
    if (
      userType === "premium" ||
      userType === "free_premium" ||
      userType === "freemium_1_month"
    ) {
      derivedUserType = "premium";
    } else {
      derivedUserType = "free";
    }

    function isInt(value) {
      return (
        !isNaN(value) &&
        (function (x) {
          return (x | 0) === x;
        })(parseFloat(value))
      );
    }

    if (crop && !_.isEmpty(crop)) {
      if (crop.videos_count && !_.isEmpty(crop.videos_count)) {
        if (crop.videos_count[userState]) {
          let videosCountObject = crop.videos_count[userState];

          if (
            videosCountObject.videos_count &&
            videosCountObject.videos_count !== "" &&
            isInt(videosCountObject.videos_count)
          ) {
            videosCount = videosCountObject.videos_count;
          }

          if (
            videosCountObject.recordings_count &&
            videosCountObject.recordings_count[derivedUserType] &&
            videosCountObject.recordings_count[derivedUserType] !== "" &&
            isInt(videosCountObject.recordings_count[derivedUserType])
          ) {
            videosCount =
              videosCount + videosCountObject.recordings_count[derivedUserType];
          }
        }
      }
    }
    return videosCount;
  }

  static getContentVideosCount(crop, userState) {
    let videosCount = 0;

    function isInt(value) {
      return (
        !isNaN(value) &&
        (function (x) {
          return (x | 0) === x;
        })(parseFloat(value))
      );
    }

    if (crop && !_.isEmpty(crop)) {
      if (crop.videos_count && !_.isEmpty(crop.videos_count)) {
        if (crop.videos_count[userState]) {
          let videosCountObject = crop.videos_count[userState];

          if (
            videosCountObject.videos_count &&
            videosCountObject.videos_count !== "" &&
            isInt(videosCountObject.videos_count)
          ) {
            videosCount = videosCountObject.videos_count;
          }
        }
      }
    }
    return videosCount;
  }
}
